import axios        from 'axios';
import authHeader   from 'services/auth-header';
import drIds        from 'services/dr-ids';
import drIdsHashed  from 'services/dr-ids-hashed';

class PreregistrationService  {
  list(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/visits?' + parameters + drIds(), { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  confirmAttendance(id, parameters) {
    var headers               = authHeader();
    headers['Content-Type']   = 'application/json';
    const docParam            = drIdsHashed();
    var dataParams            = parameters;
    dataParams.eb_doctor_id   = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/visits/' + id, parameters, { headers: headers })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new PreregistrationService();